import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const DURATION = {
  curtain: 1.5,
  text: 1,
  reveal: 3,
};

const STORAGE_KEY = 'heroAnmPlayed';
const FULL_CLIP = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';

const heroAnm = () => {
  const hero = document.querySelector('.hero');
  const loading = document.querySelector('.loading');
  if (!hero || !loading) return;

  const rectRight = hero.querySelector('.hero__rect--right');
  const rectLeft = hero.querySelector('.hero__rect--left');
  const text = hero.querySelector('.hero__text');
  const secondView = document.querySelector('.second-view');
  const body = document.body;

  gsap.registerPlugin(ScrollTrigger);

  const applyFinalState = () => {
    loading.classList.add('is-started', 'is-hidden');
    gsap.set(loading, { opacity: 0 });
    gsap.set([rectLeft, rectRight], { width: 0 });
    gsap.set(text, { opacity: 1 });
    gsap.set('.blur_rect', { attr: { height: 0, y: 1 } });
    gsap.set('.hero__deco', { clipPath: FULL_CLIP });
    gsap.set('.second-view__img', { clipPath: FULL_CLIP });
    secondView?.classList.add('is-shown');
    body.classList.add('is-loaded');
  };

  const markPlayed = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // sessionStorage が使えない環境では毎回アニメーション
    }
  };

  const hasPlayed = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  };

  // 同一セッション内の2回目以降は終了状態を即時表示
  if (hasPlayed()) {
    applyFinalState();
    return;
  }

  gsap
    .timeline()
    .add(() => {
      loading.classList.add('is-started');
    })
    .to('.loading', {
      opacity: 0,
      duration: 1,
      ease: 'none',
    }, '<1')
    .add(() => {
      loading.classList.add('is-hidden');
    })
    .to(rectRight, { width: '0', duration: DURATION.curtain })
    .to(rectLeft, { width: '0', duration: DURATION.curtain }, '<')
    .to(text, { opacity: 1, duration: DURATION.text })
    .to('.blur_rect', {
      attr: { height: 0, y: 1 },
      duration: 1.25,
      ease: 'none',
    })
    .to('.hero__deco', {
      clipPath: FULL_CLIP,
      duration: 1.5625,
      ease: 'none',
    }, '<')
    .to('.second-view__img', {
      clipPath: FULL_CLIP,
      duration: 1.5,
      ease: 'power1.out',
    }, '<1')
    .add(() => {
      secondView?.classList.add('is-shown');
    })
    .add(() => {
      body.classList.add('is-loaded');
      markPlayed();
    });
};

export default heroAnm();
